import { ArrowRightOutlined, DeleteOutlined } from '@ant-design/icons';
import AudiencesModel from '@mm/state/model/AudiencesModel';
import ConnectionModel from '@mm/state/model/ConnectionModel';
import { GoHighLevelLocation } from '@mm/state/model/GoHighLevelModel';
import TagModel from '@mm/state/model/TagModel';
import { AudienceSimpleSelect } from '@mm/stateful-components';
import { Select, Switch } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { TagsSelector } from '../TagsSelector/TagsSelector';
import styles from './GoHighLevelIntegrations.module.css';

type Props = {
  update: (params: Partial<ConnectionModel>) => void;
  remove?: () => void;
  connection: ConnectionModel;
  withAudiences: boolean;
  canDelete: boolean;
  locations: GoHighLevelLocation[];
  audiences: AudiencesModel[];
  activeFbPageId: number;
  availableTags: TagModel[];
};

export const GoHighLevelConnectionEditor = ({
  connection,
  update,
  remove,
  canDelete,
  withAudiences,
  locations,
  audiences,
  activeFbPageId,
  availableTags,
}: Props) => (
  <>
    {withAudiences && (
      <>
        <div className={styles.gridColumn}>
          <AudienceSimpleSelect
            options={audiences}
            className={styles.audiencesSelect}
            selectedAudienceId={connection?.audienceId || undefined}
            onChange={audienceId => update({ audienceId })}
          />
        </div>
        <div className={classNames(styles.gridColumn, styles.arrowColumn)}>
          <ArrowRightOutlined />
        </div>
      </>
    )}
    <div className={styles.gridColumn}>
      <Select
        className={styles.locationsSelect}
        defaultValue={connection?.data?.locationId || undefined}
        placeholder="Choose"
        onChange={locationId =>
          update({ data: { ...(connection?.data || {}), locationId } })
        }
        options={locations.map(loc => ({ value: loc.id, label: loc.name }))}
        popupClassName={styles.popup}
      />
    </div>
    <div className={styles.gridColumn}>
      <TagsSelector
        onChange={tag => {
          if (tag) {
            update({
              tags: [
                ...(connection.tags || []),
                { name: tag.name, sentAs: tag.name },
              ],
            });
          }
        }}
        onTagRemove={tag => {
          if (tag) {
            const tagIndex = (connection.tags || []).findIndex(
              connTag => connTag.name === tag.name,
            );
            if (tagIndex >= 0) {
              update({
                tags: [
                  ...(connection.tags || []).slice(0, tagIndex),
                  ...(connection.tags || []).slice(tagIndex + 1),
                ],
              });
            }
          }
        }}
        fbPageId={activeFbPageId}
        availableTags={availableTags}
        tags={(connection.tags || []).map(tag => ({
          name: tag.name,
          unsaved: false,
          kind: 'regular',
        }))}
      />
    </div>
    <div className={classNames(styles.gridColumn, styles.actionsColumn)}>
      <Switch
        defaultChecked={connection?.active}
        checkedChildren="Sync"
        unCheckedChildren="Sync"
        className={styles.switch}
        onChange={ok => update({ active: ok })}
        disabled={!connection?.id}
      />
      {canDelete && <DeleteOutlined onClick={() => remove?.()} />}
    </div>
  </>
);
